import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import { IpTable } from "@/components/IpTable";

export function TopPage() {
  const ips = useQuery({ queryKey: queryKeys.ips, queryFn: api.listIps });
  const favorites = useQuery({ queryKey: queryKeys.favorites, queryFn: api.getFavorites });

  if (ips.isLoading) return <p className="text-sm text-muted-foreground">読み込み中…</p>;
  if (ips.error) return <p className="text-sm text-destructive">読み込みに失敗しました</p>;

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">IP 一覧</h1>
      <IpTable
        data={ips.data?.ips || []}
        favorites={favorites.data?.favorite_ips || []}
      />
    </div>
  );
}
